module.exports = __webpack_public_path__ + "img/a.771e9f26.png";